<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"RECRUITER.SETTINGS" | translate}} </h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column pt-4">
        <div class="d-flex  flex-grow-1">
            <div class="tab-c">
                <div *ngFor="let item of settingsArr" class="set-tab"
                    [ngClass]="item.name==selectedSetting.name ? 'active-sett' :''" (click)="onSelectedSettings(item)">
                    {{item.name}}
                </div>
            </div>
            <div class="flex-grow-1 ps-2   ps-md-4">
                <div *ngIf="selectedSetting.id==0">
                    <div class="first-main-div">
                        <div class="time-off-settings">
                            <!-- Work days & hours section -->
                            <div class="workdays">
                                <div class="d-flex gap-2">
                                    <div class="d-flex align-items-center">Work days :</div>
                                    <div class="day-buttons">
                                        <button *ngFor="let day of workdays" [ngClass]="{ selected: day.selected }"
                                            (click)="toggleDaySelection(day)">
                                            {{ day.label }}
                                        </button>
                                    </div>
                                </div>
                                <div class="d-flex gap-2">
                                    <div class="d-flex align-items-center">Day length :</div>
                                    <div class="day-lengths mt-1">
                                        <input *ngFor="let day of workdays" [disabled]="!day.selected"
                                            [(ngModel)]="day.hours" type="number" min="0" max="12" />
                                    </div>
                                </div>
                            </div>

                            <div class="section">
                                <!-- Work days selection -->
                                <div class="work-day-hours flex-column mt-3">
                                    <div class="d-flex gap-2 mb-2">
                                        <div class="description">Default work day hours:</div>
                                    </div>
                                    <div class="time-inputs">
                                        <div class="me-2" for="from-time">From:</div>
                                        <input type="text" mask="Hh:m0:s0" class="time-input"
                                            [(ngModel)]="generalObj.default_work_hour.fr"
                                            [dropSpecialCharacters]="false" />
                                        <div class="me-2" for="to-time">To:</div>
                                        <input type="text" mask="Hh:m0:s0" class="time-input"
                                            [(ngModel)]="generalObj.default_work_hour.to"
                                            [dropSpecialCharacters]="false" />
                                    </div>
                                </div>
                                <div class="border-b"></div>
                                <!-- Time off request approval -->
                            </div>
                            <!-- Time off limitations -->
                            <div>
                                <div class="checkbox-section justify-content-between">
                                    <div>
                                        <mat-checkbox name="schedule"
                                            [(ngModel)]="generalObj.daily_limit_exceed.selected">
                                            <div class="text-wrap"> Daily limit</div>
                                            <div class="s-txt-grey">
                                                You 'll be notified when a limit is exceeded
                                            </div>
                                        </mat-checkbox>
                                    </div>
                                    <mat-select class="form-control cal-view me-2" style="width: 115px"
                                        [(ngModel)]="generalObj.daily_limit_exceed.value"
                                        [disabled]="!generalObj.daily_limit_exceed.selected">
                                        <mat-option *ngFor="let item of hoursArr"
                                            [value]="item.val">{{item.key}}</mat-option>
                                    </mat-select>
                                </div>
                                <div class="checkbox-section justify-content-between">
                                    <div>
                                        <mat-checkbox name="schedule"
                                            [(ngModel)]="generalObj.auto_clock_out_hour.selected">
                                            <div class="text-wrap"> Auto clock out</div>
                                            <div class="s-txt-grey">
                                                Employees exceeded daily limit:, will be automatically clocked out
                                            </div>
                                        </mat-checkbox>
                                    </div>
                                    <mat-select class="form-control cal-view me-2" style="width: 115px"
                                        [disabled]="!generalObj.auto_clock_out_hour.selected"
                                        [(ngModel)]="generalObj.auto_clock_out_hour.value">
                                        <mat-option *ngFor="let item of hoursArr"
                                            [value]="item.val">{{item.key}}</mat-option>
                                    </mat-select>
                                </div>
                                <div class="checkbox-section justify-content-between">
                                    <div class="w-100">
                                        <mat-checkbox name="schedule" [(ngModel)]="generalObj.show_pay_rates.selected">
                                            <div class="text-wrap">Show the diffrence between scheduled and worked
                                                time</div>
                                        </mat-checkbox>
                                    </div>
                                </div>
                                <div class="border-b"></div>
                                <div class="checkbox-section justify-content-between">
                                    <div class="d-flex">
                                        <mat-checkbox name="schedule"
                                            [(ngModel)]="generalObj.timesheet_rounding.selected">
                                            <div class="text-wrap">Timesheets rounding</div>
                                        </mat-checkbox>
                                    </div>
                                </div>
                                <div>
                                    <div class="s-txt-grey">
                                        We recommend you consult a labor or emplyment attorney in your country to
                                        ensure that you comply with rounding regulations.
                                    </div>
                                    <div class="description flex-wrap mt-1 d-flex lign-items-center"
                                        *ngIf="generalObj.timesheet_rounding.selected">
                                        <span class="d-flex align-items-center me-2">Automatically round start & end
                                            times to the nearest</span>
                                        <mat-select class="form-control cal-view me-2" style="width:120px"
                                            [(ngModel)]="generalObj.timesheet_rounding.value">
                                            <mat-option *ngFor="let item of roundingVal"
                                                [value]="item.val">{{item.key}}</mat-option>
                                        </mat-select>
                                        <span class="d-flex align-items-center gap-2">increment</span>
                                    </div>
                                </div>
                                <div class="border-b"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==1">
                    <div class="first-main-div first-main-div-1">
                        <div class="time-off-settings">
                            <div class="section">
                                <div class="b-container d-flex justify-content-between gap-2 mb-3">
                                    <div class="d-flex gap-3 align-items-center">
                                        <img src="assets/images/icons/communications.svg" alt="">
                                        <div class="title"> Week start on</div>
                                    </div>
                                    <mat-select class="form-control cal-view me-2" style="width: 115px">
                                        <mat-option *ngFor="let item of weekDaysArr"
                                            [value]="item.val">{{item.key}}</mat-option>
                                    </mat-select>
                                </div>
                                <div class="b-container d-flex justify-content-between gap-2 mb-3">
                                    <div class="d-flex gap-3 align-items-center">
                                        <img src="assets/images/icons/communications.svg" alt="">
                                        <div class="title"> Payroll cycle</div>
                                    </div>
                                    <mat-select class="form-control cal-view me-2" style="width: 115px"
                                        [(ngModel)]="generalObj.payroll_cycle.value">
                                        <mat-option *ngFor="let item of payrollCycleArr"
                                            [value]="item.val">{{item.key}}</mat-option>
                                    </mat-select>
                                </div>
                                <div class="border-b"></div>
                                <div class="checkbox-section gap-3">
                                    <mat-checkbox name="schedule" [(ngModel)]="generalObj.timesheet_approval.selected">
                                        <div class="text-wrap">Timesheets approval</div>
                                    </mat-checkbox>
                                </div>
                                <div class="s-txt-grey">
                                    You can approve users’ timesheets. The approval action will lock the
                                    timesheet entries after they are approved.
                                </div>
                                <div class="border-b"></div>
                                <div class="checkbox-section justify-content-between">
                                    <div>
                                        <mat-checkbox name="schedule"
                                            [(ngModel)]="generalObj.timesheet_review_user.selected">
                                            <div class="text-wrap">Remind users to review their timesheets</div>
                                        </mat-checkbox>
                                        <div *ngIf="generalObj.timesheet_review_user.selected==true">
                                            <div class="d-flex gap-3 align-items-start">
                                                <div for="requiresApproval" class="description">
                                                    <div class="d-flex gap-2 mb-3 mt-3">
                                                        <input type="number" class="form-control"
                                                            [(ngModel)]="generalObj.timesheet_review_user.value">
                                                        <mat-select class="form-control cal-view me-2"
                                                            [(ngModel)]="generalObj.timesheet_review_user.hmd"
                                                            style="width: 115px">
                                                            <mat-option *ngFor="let it of durationArr"
                                                                [value]="it.val">{{it.key}}</mat-option>
                                                        </mat-select>
                                                        <mat-select class="form-control cal-view me-2"
                                                            [(ngModel)]="generalObj.timesheet_review_user.af_bf"
                                                            style="width: 115px">
                                                            <mat-option *ngFor="let item of timePeriodArr"
                                                                [value]="item.val">{{item.key}}</mat-option>
                                                        </mat-select>
                                                        <div>payroll cycle end - send reminder at </div>
                                                        <input type="text" mask="Hh:m0" class="time-input"
                                                            [(ngModel)]="generalObj.timesheet_review_user.hmd_val"
                                                            [dropSpecialCharacters]="false" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="generalObj.timesheet_review_user.oth_text">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="border-b"></div>
                                <div class="checkbox-section justify-content-between">
                                    <div>
                                        <mat-checkbox name="schedule"
                                            [(ngModel)]="generalObj.timesheet_review_admin.selected">
                                            <div class="text-wrap">Remind you to approve timesheets</div>
                                        </mat-checkbox>
                                        <div *ngIf="generalObj.timesheet_review_admin.selected">
                                            <div class="d-flex gap-3 align-items-start">
                                                <div for="requiresApproval" class="description">
                                                    <div class="d-flex gap-2 mb-3 mt-3">
                                                        <input type="number" class="form-control"
                                                            [(ngModel)]="generalObj.timesheet_review_admin.value">
                                                        <mat-select class="form-control cal-view me-2"
                                                            [(ngModel)]="generalObj.timesheet_review_admin.hmd"
                                                            style="width: 115px">
                                                            <mat-option *ngFor="let item of durationArr"
                                                                [value]="item.val">{{item.key}}</mat-option>
                                                        </mat-select>
                                                        <mat-select class="form-control cal-view me-2"
                                                            [(ngModel)]="generalObj.timesheet_review_admin.af_bf"
                                                            style="width: 115px">
                                                            <mat-option *ngFor="let item of timePeriodArr"
                                                                [value]="item.val">{{item.key}}</mat-option>
                                                        </mat-select>
                                                        <div>payroll cycle end - send reminder at </div>
                                                        <input type="text" mask="Hh:m0" class="time-input"
                                                            [(ngModel)]="generalObj.timesheet_review_admin.hmd_val"
                                                            [dropSpecialCharacters]="false" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="generalObj.timesheet_review_admin.oth_text">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==2">
                    <div class="first-main-div first-main-div-2">
                        <div class="time-off-settings">
                            <div class="section">
                                <div class="title "> Overtime setting
                                </div>
                                <div>Select the overtime rules that best fits your business needs</div>
                                <div class="g-card flex-column gap-3 mt-3">
                                    <div class="title d-flex align-items-center gap-1">
                                        <mat-slide-toggle color="primary"
                                            [(ngModel)]="generalObj.weekly_overtime.selected"></mat-slide-toggle> Weekly
                                        overtime
                                    </div>
                                    <div class="border-b"> </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">Start after
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.weekly_overtime.value"
                                                    [disabled]="generalObj.weekly_overtime.selected==false"> Hours/week
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">
                                                {{ generalObj.weekly_overtime.s_m == 1 ? 'Multiplier' : 'Additional' }}
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.weekly_overtime.s_mv"
                                                    [disabled]="generalObj.weekly_overtime.selected==false">
                                                <mat-select [(ngModel)]="generalObj.weekly_overtime.s_m"
                                                    class="sel-w ms-2" panelClass="sel-we"
                                                    [disabled]="generalObj.weekly_overtime.selected==false">
                                                    <mat-option [value]="1" selected>X base wage</mat-option>
                                                    <mat-option [value]="2">+ base wage</mat-option>
                                                </mat-select>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="g-card flex-column gap-3 mt-3">
                                    <div class="title d-flex align-items-center gap-1">
                                        <mat-slide-toggle color="primary"
                                            [(ngModel)]="generalObj.daily_overtime.selected"></mat-slide-toggle> Daily
                                        overtime
                                    </div>
                                    <div class="border-b"> </div>
                                    <div class="d-flex gap-2">
                                        <div class="d-flex align-items-center">on days :</div>
                                        <div class="day-buttons">
                                            <button *ngFor="let day of workdays"
                                                [ngClass]="{ selected: getSelectedDays('daily_overtime',day.value) }"
                                                (click)="onAddDaysOvertime('daily_overtime',day)">{{ day.label }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">Start after
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.daily_overtime.value"> Hours</span>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2"> {{
                                                generalObj.daily_overtime.s_m == 1 ? 'Multiplier' : 'Additional' }}
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.daily_overtime.s_mv">
                                                <mat-select [(ngModel)]="generalObj.daily_overtime.s_m"
                                                    class="sel-w ms-2" panelClass="sel-we">
                                                    <mat-option [value]="1" selected>X base wage</mat-option>
                                                    <mat-option [value]="2">+ base wage</mat-option>
                                                </mat-select>
                                            </span>
                                        </div>
                                    </div>
                                </div>




                                <div class="g-card flex-column gap-3 mt-3">
                                    <div class="title d-flex align-items-center gap-1">
                                        <mat-slide-toggle color="primary"
                                            [(ngModel)]="generalObj.premium_time.selected"></mat-slide-toggle> Premium
                                        time
                                    </div>
                                    <div class="border-b"> </div>
                                    <div class="d-flex gap-2">
                                        <div class="d-flex align-items-center">on days :</div>
                                        <div class="day-buttons">
                                            <button *ngFor="let day of workdays"
                                                [ngClass]="{ selected: getSelectedDays('premium_time',day.value) }"
                                                (click)="onAddDaysOvertime('premium_time',day)">{{ day.label }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">Start after
                                                <input type="number" [(ngModel)]="generalObj.premium_time.value"
                                                    class="form-control"> Hours</span>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2"> Custom
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.premium_time.s_mv">
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="g-card flex-column gap-3 mt-3">
                                    <div class="title d-flex align-items-center gap-1">
                                        <mat-slide-toggle color="primary"
                                            [(ngModel)]="generalObj.night_premium.selected"></mat-slide-toggle>Night
                                        Premium
                                    </div>
                                    <div class="border-b"> </div>

                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">Between
                                                <input type="number" [(ngModel)]="generalObj.night_premium.fr"
                                                    class="form-control">
                                                To <input type="number" [(ngModel)]="generalObj.night_premium.to"
                                                    class="form-control"></span>
                                            <!-- <span class="d-flex align-items-center gap-2">Start after
                                          <input type="number" [(ngModel)]="generalObj.night_premium.value" class="form-control">
                                          Hours/week</span> -->
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2"> {{
                                                generalObj.night_premium.s_m == 1 ? 'Multiplier'
                                                : 'Additional' }}
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.night_premium.s_mv">
                                                <mat-select class="sel-w ms-2" panelClass="sel-we"
                                                    [(ngModel)]="generalObj.night_premium.s_m">
                                                    <mat-option [value]="1" selected>X base wage</mat-option>
                                                    <mat-option [value]="2">+ base wage</mat-option>
                                                </mat-select>
                                            </span>
                                        </div>
                                    </div>
                                </div>


                                <div class="g-card flex-column gap-3 mt-3">
                                    <div class="title d-flex align-items-center gap-1">
                                        <mat-slide-toggle [(ngModel)]="generalObj.partial_day_overtime.selected"
                                            color="primary"></mat-slide-toggle> Partial day overtime
                                    </div>
                                    <div class="border-b"> </div>
                                    <div class="d-flex gap-2">
                                        <div class="d-flex align-items-center">on days :</div>
                                        <div class="day-buttons">
                                            <button *ngFor="let day of workdays"
                                                [ngClass]="{ selected: getSelectedDays('partial_day_overtime',day.value) }"
                                                (click)="onAddDaysOvertime('partial_day_overtime',day)"> {{ day.label }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">Start after
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.partial_day_overtime.fr">
                                                Hours <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.partial_day_overtime.to"></span>
                                            <!-- <span class="d-flex align-items-center gap-2">Start after
                                          <input type="number" class="form-control" [(ngModel)]="generalObj.partial_day_overtime.value">
                                          Hours</span> -->
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2"> {{
                                                generalObj.partial_day_overtime.s_m == 1 ?
                                                'Multiplier' : 'Additional' }}
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.partial_day_overtime.s_mv">
                                                <mat-select [(ngModel)]="generalObj.partial_day_overtime.s_m"
                                                    class="sel-w ms-2" panelClass="sel-we">
                                                    <mat-option [value]="1" selected>X base wage</mat-option>
                                                    <mat-option [value]="2">+ base wage</mat-option>
                                                </mat-select>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="g-card flex-column gap-3 mt-3">
                                    <div class="title d-flex align-items-center gap-1">
                                        <mat-slide-toggle color="primary"
                                            [(ngModel)]="generalObj.consecutive_days_overtime.selected"></mat-slide-toggle>
                                        Consecutive day overtime
                                    </div>
                                    <div class="border-b"> </div>
                                    <div class="d-flex gap-2">
                                        <div class="d-flex align-items-center">on days :</div>
                                        <div class="day-buttons">
                                            <button *ngFor="let day of workdays"
                                                [ngClass]="{ selected: getSelectedDays('consecutive_days_overtime',day.value) }"
                                                (click)="onAddDaysOvertime('consecutive_days_overtime',day)"> {{
                                                day.label }} </button>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">Start on the
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.consecutive_days_overtime.st_on">
                                                Consecutive day</span>

                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">Start after
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.consecutive_days_overtime.value">
                                                Hours</span>
                                        </div>
                                    </div>

                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">
                                                {{ generalObj.consecutive_days_overtime.s_m ==1 ? 'Multiplier' :
                                                'Additional' }}
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.consecutive_days_overtime.s_mv">
                                                <mat-select [(ngModel)]="generalObj.consecutive_days_overtime.s_m"
                                                    class="sel-w ms-2" panelClass="sel-we">
                                                    <mat-option [value]="1" selected>X base wage</mat-option>
                                                    <mat-option [value]="2">+ base wage</mat-option>
                                                </mat-select>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="g-card flex-column gap-3 mt-3">
                                    <div class="title d-flex align-items-center gap-1">
                                        <mat-slide-toggle color="primary"
                                            [(ngModel)]="generalObj.pay_period_overtime.selected"></mat-slide-toggle>
                                        Pay period overtime
                                    </div>
                                    <div class="border-b"> </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">Start after
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.pay_period_overtime.value">
                                                Hours/week</span>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-3">
                                        <div for="requiresApproval" class="description">
                                            <span class="d-flex align-items-center gap-2">
                                                {{ generalObj.pay_period_overtime.s_m == 1 ? 'Multiplier' : 'Additional'
                                                }}
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="generalObj.pay_period_overtime.s_mv">
                                                <mat-select [(ngModel)]="generalObj.pay_period_overtime.s_m"
                                                    class="sel-w ms-2" panelClass="sel-we">
                                                    <mat-option [value]="1" selected>X base wage</mat-option>
                                                    <mat-option [value]="2">+ base wage</mat-option>
                                                </mat-select>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==3">
                    <div class="first-main-div first-main-div-3">
                        <div class="time-off-settings">
                            <div class="section">
                                <mat-radio-group aria-label="Select an option" [(ngModel)]="breakType">
                                    <div class="checkbox-section gap-3">
                                        <mat-radio-button value="disable_breaks"></mat-radio-button>
                                        <div class="ms-n-5">
                                            <div class="d-flex gap-3">
                                                <div for="requiresApproval" class="description">
                                                    <span class="title">Disabled</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="border-b"></div>
                                    <div class="checkbox-section gap-3">
                                        <div class="ms-n-5">
                                            <div class="d-flex gap-3">
                                                <mat-radio-button value="manual_breaks"></mat-radio-button>
                                                <div for="requiresApproval" class="description">
                                                    <span class="title">Manual breaks</span>
                                                </div>
                                            </div>
                                            <div class="s-txt-grey mt-1">
                                                Manually added breaks allow users to track their break time during their
                                                work day with a dedicated button
                                            </div>
                                        </div>
                                    </div>
                                    <div class="border-b"></div>
                                    <div class="checkbox-section gap-3">
                                        <div class="ms-n-5">
                                            <div class="d-flex gap-3">
                                                <mat-radio-button value="automatic_breaks"></mat-radio-button>
                                                <div for="requiresApproval" class="description">
                                                    <span class="title">Automatic breaks</span>
                                                </div>
                                            </div>
                                            <div class="s-txt-grey mt-1">
                                                Manually added breaks allow users to track their break time during their
                                                work day with a dedicated "take a break" button
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center gap-3 mt-2"
                                        *ngFor="let item of automaticArr;let i=index">
                                        <div class="d-flex gap-2 align-items-center">
                                            <span *ngIf="i==0">Deduct</span>
                                            <span *ngIf="i!=0">And another</span>
                                            <mat-select class="form-control cal-view" style="width: 120px"
                                                [(ngModel)]="item.value"
                                                (selectionChange)="onTimeChange($event.value,i)">
                                                <mat-option *ngFor="let break of breakHourArr"
                                                    [value]="break.value">{{break.key}}</mat-option>
                                            </mat-select>
                                        </div>
                                        <div class="d-flex gap-2 align-items-center">
                                            <span *ngIf="i==0">Break time after daily total of</span>
                                            <span *ngIf="i!=0">after</span>
                                            <mat-select class="form-control cal-view" style="width: 120px"
                                                [(ngModel)]="item.hmd_val">
                                                <mat-option *ngFor="let hr of hoursArr"
                                                    [value]="hr.val">{{hr.key}}</mat-option>
                                            </mat-select>
                                        </div>
                                        <div class="cursor-pointer" (click)="onDeleteBreak(i)" *ngIf="i!=0">
                                            <img src="assets/images/icons/delete-icon.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="primary-color cursor-pointer" (click)="onAddAutomaticBreak()">+ Add
                                        Break</div>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==4">
                    <div class="first-main-div first-main-div-4">
                        <div class="time-off-settings">
                            <div class="section">
                                <div class="title mb-2">Shift attachment </div>
                                <div>Use shift attachments to add items such as manager signature and
                                    more to a shift.</div>
                                <div class="border-b"></div>
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex gap-2 align-items-center">
                                        <mat-checkbox [(ngModel)]="generalObj.manager_sign.selected"></mat-checkbox>
                                        <img class="ic-t" src="assets/images/icons/user_icon.svg" alt="">
                                        <div class="l-h-n">Manager signature</div>
                                    </div>
                                </div>
                                <div class="border-b"></div>
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex gap-2 align-items-center">
                                        <mat-checkbox
                                            [(ngModel)]="generalObj.employee_confirm_hours.selected"></mat-checkbox>
                                        <img class="ic-t" src="assets/images/icons/user_icon.svg" alt="">
                                        <div class="l-h-n">I confirm my hours</div>
                                    </div>
                                </div>
                                <div class="border-b"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==5">
                    <div class="first-main-div first-main-div-5">
                        <div class="time-off-settings">
                            <div class="section">
                                <div class="geolocation-container">
                                    <div class="title-2">Geolocation</div>
                                    <div class="geolocation-description">
                                        By enabling geolocation, you will receive the location where a clock in or clock
                                        out were performed
                                    </div>
                                    <div class="d-flex ">
                                        <mat-radio-group [(ngModel)]="generalObj.geolocation.track">
                                            <div class="options-container">
                                                <div class="option-card"
                                                    [ngClass]="{ 'selected': generalObj.geolocation.track == '1' }">
                                                    <div class="option-img">
                                                        <img src="assets/images/map.jpg" alt="">
                                                    </div>
                                                    <div class="title mb-2">
                                                        <mat-radio-button [value]="1"></mat-radio-button>
                                                        Breadcrumbs (live-tracking)
                                                    </div>
                                                    <div>Track users' live location and route while they're on the
                                                        clock.</div>
                                                    {{geoLocationObj.track}}
                                                </div>
                                                <div class="option-card"
                                                    [ngClass]="{ 'selected': generalObj.geolocation.track == '2' }">
                                                    <div class="option-img"> <img src="assets/images/map.jpg" alt="">
                                                    </div>
                                                    <div class="title mb-2">
                                                        <mat-radio-button [value]="2"></mat-radio-button>
                                                        Clock in & out
                                                    </div>
                                                    <div>Track users' clock in and clock out locations</div>
                                                </div>
                                            </div>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==6">
                    <div class="first-main-div first-main-div-4">
                        <div class="time-off-settings">
                            <div class="section">
                                <div class="workdays mb-4">
                                    <div class="d-flex flex-column gap-2">
                                        <div class="d-flex title align-items-center">Reminders active on :</div>
                                        <div class="day-buttons">
                                            <button *ngFor="let day of remDays" [ngClass]="{ selected: day.selected }"
                                                (click)="toggleDaySelection(day)">
                                                {{ day.label }} </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex title align-items-center mt-2">Employee reminders </div>
                                <div class="checkbox-section justify-content-between">
                                    <div>
                                        <mat-checkbox name="schedule"
                                            [(ngModel)]="generalObj.employee_clockin_at.selected">
                                            <div class="text-wrap">Remind employees to clock in at:</div>
                                        </mat-checkbox>
                                    </div>
                                    <input type="text" mask="Hh:m0" class="time-input"
                                        [(ngModel)]="generalObj.employee_clockin_at.value"
                                        [dropSpecialCharacters]="false" />
                                </div>
                                <div class="checkbox-section justify-content-between">
                                    <div>
                                        <mat-checkbox name="schedule"
                                            [(ngModel)]="generalObj.employee_clockout_at.selected">
                                            <div class="text-wrap">Remind employees to clock in out at:</div>
                                        </mat-checkbox>
                                    </div>
                                    <input type="text" mask="Hh:m0" class="time-input"
                                        [(ngModel)]="generalObj.employee_clockout_at.value"
                                        [dropSpecialCharacters]="false" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==7">
                    <div class="first-main-div first-main-div-7">
                        <div class="time-off-settings">
                            <div class="section">
                                <div class="notification-settings">

                                    <div class="header mb-5 g-card-2 gap-2 justify-content-between">
                                        <h2>Time clock notifications</h2>
                                    </div>
                                    <div class="notification-list mb-4">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Get notified when users:</th>
                                                    <th>Mobile</th>
                                                    <th>Email</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Added a new shift</td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.add_new_shift.mobile"></mat-slide-toggle>
                                                    </td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.add_new_shift.email"></mat-slide-toggle>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Edited a shift</td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.edit_shift.mobile"></mat-slide-toggle>
                                                    </td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.edit_shift.email"></mat-slide-toggle>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Exceeds work hour limit</td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.exceed_work_hour.mobile"></mat-slide-toggle>
                                                    </td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.exceed_work_hour.email"></mat-slide-toggle>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Auto clock out</td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.auto_clock_out.mobile"></mat-slide-toggle>
                                                    </td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.auto_clock_out.email"></mat-slide-toggle>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span>
                                                            <input class="form-control d-flex justify-content-center"
                                                                type="number"
                                                                [(ngModel)]="generalObj.request_pending_approval.value">
                                                        </span>
                                                    </td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.request_pending_approval.mobile"></mat-slide-toggle>
                                                    </td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.request_pending_approval.email"></mat-slide-toggle>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Submitted their timesheet
                                                        <p class="note"> Will be sent to you who manage your timesheets
                                                            and
                                                            are direct managers. </p>
                                                    </td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.submitted_timesheet.mobile"></mat-slide-toggle>
                                                    </td>
                                                    <td><mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.submitted_timesheet.email"></mat-slide-toggle>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="notification-list pt-4">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Get notified when Admins: </th>
                                                    <th>Mobile</th>
                                                    <th>Email</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Approved/Declined a shift</td>
                                                    <td class="p-90">
                                                        <mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.app_disapp_job.mobile"></mat-slide-toggle>
                                                    </td>
                                                    <td class="p-90">
                                                        <mat-slide-toggle color="primary"
                                                            [(ngModel)]="generalObj.app_disapp_job.email"></mat-slide-toggle>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedSetting.id==8">
                    <div class="first-main-div first-main-div-8">
                        <div class="time-off-settings">
                            <div class="section">
                                <div class="title mb-2">Limit when and how users can track time</div>
                                <div>Limit users' ability to clock in, so they can track time only for assigned shifts
                                    in their schedule. Set up an automated clock out at the end of a shift to avoid
                                    overtime and mistakes</div>
                                <div class="b-div mt-3">
                                    <div class="checkbox-section mt-0 pb-0 p-4 gap-0">
                                        <mat-checkbox class="c-cb"
                                            [(ngModel)]="generalObj.clock_in_limitation.selected"></mat-checkbox>
                                        <div>
                                            <div class="d-flex gap-3 mb-1">
                                                <div for="requiresApproval" class="">
                                                    <span class="title">Clock in limitation </span>
                                                </div>
                                            </div>
                                            <div class="">
                                                <mat-radio-group [(ngModel)]="generalObj.clock_in_limitation.cl_li"
                                                    (change)="onLimitationValueChange($event,'clock_limit')"
                                                    [disabled]="!generalObj.clock_in_limitation.selected">
                                                    <div class="d-flex align-items-center gap-2 mb-2">
                                                        <mat-radio-button [value]="1"></mat-radio-button>
                                                        Users can only clock in within their schedule shifts
                                                    </div>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <mat-radio-button [value]="2"></mat-radio-button>
                                                        <div for="requiresApproval" class="">
                                                            <span class="d-flex flex-wrap align-items-center gap-2">
                                                                Highlight if employee worked <input type="number"
                                                                    class="form-control form-control-50"
                                                                    [disabled]="!generalObj.clock_in_limitation.selected"
                                                                    [(ngModel)]="generalObj.clock_in_limitation.value">
                                                                minutes more then scheduled</span>
                                                        </div>
                                                    </div>
                                                </mat-radio-group>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="border-b"></div>
                                    <div class="checkbox-section mt-0 pt-0 p-4 gap-0">
                                        <mat-checkbox class="c-cb"
                                            [(ngModel)]="generalObj.auto_clockout_time.selected"></mat-checkbox>
                                        <div>
                                            <div class="d-flex gap-3 mb-1">
                                                <div for="requiresApproval" class="">
                                                    <span class="title">Auto clock out at the end of a shift </span>
                                                </div>
                                            </div>
                                            <div class="">
                                                <mat-radio-group [(ngModel)]="generalObj.auto_clockout_time.cl_li"
                                                    [disabled]="!generalObj.auto_clockout_time.selected"
                                                    (change)="onLimitationValueChange($event,'auto_clockout')">
                                                    <div class="d-flex align-items-center gap-2 mb-2">
                                                        <mat-radio-button [value]="1"></mat-radio-button>
                                                        Users will be automatically clocked out at the end of their
                                                        shift
                                                    </div>
                                                    <div class="d-flex  gap-2">
                                                        <mat-radio-button [value]="2"></mat-radio-button>
                                                        <div for="requiresApproval" class="">
                                                            <div class="d-flex  align-items-center gap-2">
                                                                If users didn't clock out at the end of their shift,
                                                                clock them out automatically
                                                                <input type="number"
                                                                    class="form-control form-control-50"
                                                                    [disabled]="!generalObj.auto_clockout_time.selected"
                                                                    [(ngModel)]="generalObj.auto_clockout_time.value">
                                                                minutes after their shift ends
                                                            </div>
                                                        </div>
                                                    </div>
                                                </mat-radio-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="border-b"></div>
                                <div class="title mb-2">Custom limit by days
                                </div>
                                <div>Set daily boundaries for clock in and clock out times. Users won't be able to clock
                                    in prior to the daily designated times and will be automatically clocked out once
                                    reaching the daily hour limit</div>
                                <div class="workdays b-div p-4">
                                    <div class="d-flex gap-2">
                                        <div class="day-buttons w-100 d-flex flex-column gap-1">
                                            <div class="d-row" *ngFor="let day of limitationArr">
                                                <button [ngClass]="{ selected: day.selected }"
                                                    (click)="toggleDaySelection(day)">{{ day.val }}
                                                </button>
                                                <div>Clock in available from</div>
                                                <input type="text" mask="Hh:m0" class="time-input" [(ngModel)]="day.fr"
                                                    [dropSpecialCharacters]="false" [disabled]="!day.selected" />
                                                <div>Auto clock out at</div>
                                                <input type="text" mask="Hh:m0" class="time-input" [(ngModel)]="day.to"
                                                    [dropSpecialCharacters]="false" [disabled]="!day.selected" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="item-footer pt-4">
        <button mat-raised-button color="primary" class="auth-form-btn" type="submit"
            (click)="onSubmitRules()">{{"BUTTON.SAVE" |
            translate
            }}</button>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>